<div
  class="ancillary-bundle-selection flex flex--column"
  [attr.data-testid]="'ancillary-bundle-selection-' + category()"
>
  <fcom-product-card
    class="ps-medium-b"
    [originalPrice]="product()?.originalPrice | finNonZeroAmount: hideZeroPrices() | finPrice | finEmpty: ''"
    [title]="product()?.title"
    [detailText]="product()?.description | finStripHtml | finEmpty: ''"
    [showDetailText]="true"
    [hideButton]="true"
    [image]="product()?.image"
    [productTags]="product()?.productTags ?? []"
    [useNewProductCardLayout]="true"
  />

  <hr class="ms-medium-y border-primary" aria-hidden="true" />

  @for (notification of notifications(); track notification.key; let last = $last) {
    <fcom-notification
      class="ps-medium-y"
      [attr.data-testid]="'combo-notification-' + notification.theme"
      [theme]="notification.theme"
      [iconName]="notification.iconName"
    >
      @if (notification.key | finHasLocalizationKey) {
        <span [innerHTML]="notification.key | finLocalization | finSafe: 'html'"></span>
      }
      @if (notification.reason) {
        <span
          [innerHTML]="notification.reason.key | finLocalization: notification.reason.data | finSafe: 'html'"
        ></span>
      }
    </fcom-notification>
  }

  @if (!selectionBlocked() && constituents(); as bundleConstituents) {
    @let bundleItems = bundleItemByPax();
    @let selections = selectionsByPax();
    @for (passenger of passengers(); track passenger.id) {
      <fin-bundle-offer-card
        class="ps-medium-y"
        [passenger]="passenger"
        [category]="category()"
        [fragmentId]="flight().id"
        [constituents]="bundleConstituents"
        [bundleItem]="bundleItems[passenger.id] ?? null"
        [selectedForPassenger]="!!selections[passenger.id]"
        (addBundle)="addBundle(passenger)"
        (removeBundle)="removeBundle(passenger)"
      />
    }
  }
</div>
